import { useCallback } from "react";
import { useRevalidator } from "react-router";
import { useIdleTimer } from "./use-idle-timer.hook";

interface UseAutoRefreshProductsOptions {
	enabled?: boolean;
}

// 2-hour timeout chosen to balance fresh data for returning users with minimal server load
const IDLE_TIMEOUT = 2 * 60 * 60 * 1000;

export function useAutoRefreshProducts({
	enabled = true,
}: UseAutoRefreshProductsOptions = {}) {
	const revalidator = useRevalidator();

	// Trigger revalidation when user returns after being idle
	// Only revalidate if not already in progress to avoid duplicate requests
	const handleIdle = useCallback(() => {
		if (revalidator.state === "idle") {
			revalidator.revalidate();
		}
	}, [revalidator]);

	const { isIdle } = useIdleTimer({
		timeout: IDLE_TIMEOUT,
		onIdle: handleIdle,
		enabled,
	});

	return {
		isIdle,
		isRefreshing: revalidator.state === "loading",
	};
}
